import { Dispatch } from '@reduxjs/toolkit';
import { request, METHODS } from '../../utils/http';

const enterpriseUri = '/enterprise';

export function getEnterpriseApi(dispatch: Dispatch) {
	return request(dispatch, enterpriseUri, METHODS.GET);
}
